/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import FavoritesToggle from './components/FavoritesToggle';

/* utilities */
import { parseDataToProps } from '~/utilities';

const FavoritesToggleNodes = Array.from(document.querySelectorAll("[data-favorites-toggle]"));
[...FavoritesToggleNodes].forEach((node) => render(<FavoritesToggle {...parseDataToProps(node.dataset)} />, node));
